import { Button, Grid } from "@dealer-center/core-components";
import { useCompareTool } from "@dealer-center/core-custom-components";
import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";
import { useDealerCodesGetTypesForCompare } from "@dealer-center/ddc-pages-resources-fetch";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { CompareComponent } from "./compareComponent";

const exampleAnalyticsConfiguration = {
  eventName: "Compare Tool Opened"
};
export const CompareTool = () => {
  const [enabled, setEnabled] = useState(false);
  const { accountEntity } = useOutletContext<{
    accountEntity: AccountEntity;
  }>();

  const [accountToCompareFrom, setAccountToCompareFrom] = useState<string>(
    accountEntity.id
  );
  const fromData = useDealerCodesGetTypesForCompare(
    !enabled ? undefined : accountToCompareFrom
  );
  const [accountToCompareTo, setAccountToCompareTo] = useState<string>("");
  const toData = useDealerCodesGetTypesForCompare(
    !enabled ? undefined : accountToCompareTo
  );
  const compareTool = useCompareTool({
    title: "Compare Resources",
    onClosed: () => {
      setEnabled(false);
    },
    compareFromComponent: (
      <CompareComponent
        placeholder="Compare From"
        selectedValue={accountToCompareFrom}
        onChange={setAccountToCompareFrom}
      />
    ),
    compareToComponent: (
      <CompareComponent
        placeholder="Compare To"
        selectedValue={accountToCompareTo}
        onChange={setAccountToCompareTo}
      />
    )
  });
  // TODOL Should the fromData and toData be used here? Or should they just be passed into the compareTool when it's invoked?
  useEffect(() => {
    if (!enabled) return;
    compareTool.open({
      from: {
        label: accountToCompareFrom,
        value: fromData
      },
      to: {
        label: accountToCompareTo,
        value: toData
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    enabled,
    accountToCompareFrom,
    accountToCompareTo,
    fromData.dataUpdatedAt,
    toData.dataUpdatedAt
  ]);

  return (
    <Grid>
      <Button
        analyticsConfiguration={exampleAnalyticsConfiguration}
        buttonStyle="secondary"
        onClick={() => {
          setEnabled(true);
          setAccountToCompareTo("");
          setAccountToCompareFrom(accountEntity.id);
        }}
      >
        Compare
      </Button>
      {compareTool.Modal}
    </Grid>
  );
};
